import { Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExploreReveal } from "./ExploreReveal";

type ExploreFooterCtaProps = {
  signupUrl: string;
  browsePath: string;
};

export function ExploreFooterCta({
  signupUrl,
  browsePath,
}: ExploreFooterCtaProps) {
  const { t } = useTranslation();

  return (
    <section className="explore-footer-cta explore-section--surface-blue">
      <ExploreReveal>
        <h2 className="explore-display-title">{t("Explore_Footer_Title")}</h2>
        <p className="explore-lead">{t("Explore_Footer_Lead")}</p>
      </ExploreReveal>
      <ExploreReveal delayMs={100}>
        <div className="explore-footer-actions">
          <Link to={signupUrl}>
            <Button type="primary" size="large">
              {t("Explore_Start_Free")}
            </Button>
          </Link>
          <Link to={browsePath}>
            <Button size="large">{t("Explore_Browse_Properties")}</Button>
          </Link>
        </div>
      </ExploreReveal>
    </section>
  );
}
